import React from "react"
import { Control, Controller } from "react-hook-form"
import InputMask from "react-input-mask"
import { Input } from "components/ui/input"
import { cn } from "@/utils/shadcn-utils"

function IfuInput({name, control}: {name: string; control: Control}) {
  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={{
          required: "Veuillez renseigner l'IFU",
          validate: (value: string) =>
            value
              ? value
                .replaceAll(/[_*\s]/g, "")
                .trim().length === 13 ||
              "Veuillez renseigner le numéro d'Identification Fiscal Unique de l'entreprise"
              : "",
        }}
        render={({ field, fieldState: { error, isTouched } }) => (
          <>
            <InputMask
              {...field}
              mask="9 9999 9999 9999"
              placeholder="X XXXX XXXX XXXX"
              onBlur={field.onBlur}
              onChange={(e) =>
                field.onChange(e.target.value.replaceAll(" ", ""))
              }>
              {(inputProps) => (
                <Input
                  {...inputProps}
                  className={cn("uppercase", (error && isTouched) ? "form--error" : "form--custom")}
                  type="text"
                />
              )}
            </InputMask>
          </>
        )}
      />
    </>
    )
  }

  export default IfuInput